import React, { useEffect, useState } from "react";
import styling from "./Customers.module.css";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import { deleteCustomer } from "../../../../redux/actions/actions";
import { notify, ToastContainer } from "../../../Notify/Notify";
import firebase from "../../../../firebase/firebase";

function Customers({ guestUser }) {
  const customers = useSelector((state) => state.customers);
  const userInfo = useSelector((state) => state.user);
  const [totalCustomers, setTotalCustomers] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    let localArr = [];
    for (let item of Object.entries(customers)) {
      localArr.push(item);
    }
    localArr = localArr.sort((a, b) => a[0].localeCompare(b[0]));
    setTotalCustomers(localArr);
  }, [customers]);

  const removeCustomer = (customer) => {
    if (window.confirm("Are you sure you want to delete this customer?")) {
      const key = customer[1].customerPhone;
      const filteredCustomers = { ...customers };
      delete filteredCustomers[key];

      const db = firebase.firestore();
      db.collection("shops")
        .doc(userInfo.shopName)
        .update({
          customers: filteredCustomers,
        })
        .then(() => {
          notify("success", "Deleted customer successfully");
          dispatch(deleteCustomer(filteredCustomers));
        })
        .catch(() => {
          notify("error", "Something went wrong");
        });
    }
  };

  const showActions = userInfo.status === "admin" || guestUser;

  return (
    <>
      <div className={styling.Customers}>
        {totalCustomers.length ? (
          <div className={styling.tableCard}>
            <div className={styling.tableHeader}>
              <h2>Customers</h2>
              <span className={styling.tableMeta}>
                {totalCustomers.length} customer
                {totalCustomers.length > 1 ? "s" : ""}
              </span>
            </div>

            <div className={styling.tableWrapper}>
              <table cellSpacing="0">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Customer Name</th>
                    <th>Phone</th>
                    {showActions && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {totalCustomers.map((customer, index) => (
                    <tr key={customer[0]}>
                      <td>{index + 1}</td>
                      <td>{customer[1].customerName}</td>
                      <td>{customer[1].customerPhone}</td>
                      {showActions && (
                        <td className={styling.actionCell}>
                          <button
                            type="button"
                            className={`${styling.iconButton} ${
                              guestUser && "guestUserGrey"
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              if (!guestUser) {
                                removeCustomer(customer);
                              }
                            }}
                            title={
                              guestUser
                                ? "Sign in to delete customers"
                                : "Delete customer"
                            }
                          >
                            <AiOutlineDelete className={styling.deleteIcon} />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {guestUser && (
              <p className={styling.guestInfo}>
                You’re in demo mode. Sign in to manage your real customers.
              </p>
            )}
          </div>
        ) : (
          <div className={styling.emptyState}>
            <h2>No customers yet</h2>
            <p>
              Customers will automatically appear here when you create bills
              using their name and phone number.
            </p>
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
}

export default Customers;
